import { useEffect } from "react"
import toast from "react-hot-toast"
import { Outlet, useNavigate } from "react-router-dom"
import { accountInactivePath, signInPath } from "~/common/paths"
import { useCurrentUserMaybe } from "../auth/CurrentUserContext"

export const RequireUserSignedIn = () => {
  const navigate = useNavigate()
  const { currentUser, result } = useCurrentUserMaybe()

  useEffect(() => {
    if (!currentUser && !result.loading) {
      toast.error("Please sign in to continue.")
      navigate(signInPath.pattern)
    }

    if (currentUser && currentUser.discarded) {
      navigate(accountInactivePath({}))
    }
  }, [currentUser, result.loading, navigate])

  if (currentUser) {
    return <Outlet />
  }

  return null
}
